import {AttrsSchema} from 'panel';

import {ButtonSize, ButtonTheme, ButtonType} from 'common/components/button/constants';
import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {TooltipAttrs} from 'common/components/tooltip/types';

import {BaseButtonAttrs, ButtonBase} from '../base/button';
import {template} from './template';
import css from './index.styl?inline';

export interface ButtonJsxProps {
  attrs?: ButtonAttrs;
}

type Attrs = {
  class?: string;
  'highlight-icon'?: boolean;
  icon?: string;
  size?: ButtonSize;
  theme?: ButtonTheme;
  type?: ButtonType;
  pressed?: boolean;
  tooltip?: TooltipAttrs;
};

export type ButtonAttrs = BaseButtonAttrs & Attrs;

export class Button extends ButtonBase<Attrs> {
  static get attrsSchema(): AttrsSchema<ButtonAttrs> {
    return {
      ...super.attrsSchema,
      class: `string`,
      'highlight-icon': `boolean`,
      icon: `string`,
      size: {type: `string`, enum: Object.values(ButtonSize), default: ButtonSize.Medium},
      theme: {type: `string`, enum: Object.values(ButtonTheme), default: ButtonTheme.Secondary},
      type: {type: `string`, enum: Object.values(ButtonType), default: ButtonType.Info},
      pressed: `boolean`,
      tooltip: `json`,
    };
  }

  get config() {
    return Object.assign(super.config, {
      css,
      template,
      helpers: {
        ...super.config.helpers,
        ButtonType,
      },
    });
  }
}

export const ButtonEl = defineAndMakeJsxFactory<ButtonJsxProps>(`mp-button`, Button);
